<script>
  import TabelaDetalheLinha from './TabelaDetalheLinha.vue';
  
  export default {
    props: {
      dados: {
        type: Array,
        required: true,
      }
    },
    components: {TabelaDetalheLinha},
    data() {
      return {
        indiceAperto: null, 
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      mostrarEsconder(i) {
        if (this.indiceAperto === i)
          this.indiceAperto = null;
        else
          this.indiceAperto = i;
      }
    },
    computed: {
      fupef() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUPEF';
      },
    },
  }
</script>

<template>
  <div>
    <div class="alert alert-info" role="alert" v-if="fupef">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group no-margins">
            <dl class="col-xs-12">
              <dt>Observa&ccedil;&atilde;o</dt>
              <dd>
                Para mensalidades vencidas, consulte a funda&ccedil;&atilde;o.
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>Curso</th>
          <th>Turma</th>
        </tr>
      </thead>
      <tabela-detalhe-linha v-for="(item, i) in dados"
                            @click="mostrarEsconder(i)"
                            :open="indiceAperto === i"
                            :dados="item">
      </tabela-detalhe-linha>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/curso/componentes/TabelaDetalhe.vue